'use client'

import { I18nDictionary, useI18n } from '@/components/i18n/lang-context'
import { PressArticleCard } from '@/components/jbda/press-article-card'
import { Section } from '@/components/jbda/section'
import { SectionTitle } from '@/components/jbda/section-title'
import { FlexCol } from '@/components/ui/flex'
import Link from 'next/link'
import { useRef } from 'react'
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa'
import { Article, PRESS_ARTICLES } from './lb-press-articles'

const I18N: I18nDictionary = {
  title: {
    en: 'They talk about us',
    fr: 'Ils parlent de nous'
  },
  see_more: {
    en: 'See more...',
    fr: 'Voir plus...'
  }
}

export function LBPress() {
  const i18n = useI18n(I18N)
  const scrollContainerRef = useRef<HTMLDivElement>(null)

  const scrollAmount = 320

  const handleScrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: -scrollAmount, behavior: 'smooth' })
    }
  }

  const handleScrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' })
    }
  }

  return (
    <Section contentClassName='py-12 md:py-20 md:pt-12'>
      <FlexCol className='w-full items-center gap-8'>
        <SectionTitle title={i18n.title} />
        <div className='relative w-full'>
          <button
            onClick={handleScrollLeft}
            className='absolute left-0 top-1/2 z-10 -translate-y-1/2 rounded-full bg-white/80 p-2 shadow-md transition hover:bg-white focus:outline-none md:-left-4'
            aria-label='Scroll left'
          >
            <FaChevronLeft className='h-6 w-6 text-primary' />
          </button>
          <div
            ref={scrollContainerRef}
            className='pretty-scrollbar flex w-full snap-x scroll-pl-1 space-x-4 overflow-x-auto scroll-smooth p-4'
          >
            {PRESS_ARTICLES.map((item: Article, index) => (
              <div
                key={index}
                className='flex w-80 min-w-[296px] snap-start flex-col sm:w-96'
              >
                <PressArticleCard article={item} lang='fr-FR' isLink={false} />
              </div>
            ))}
          </div>
          <button
            onClick={handleScrollRight}
            className='absolute right-0 top-1/2 z-10 -translate-y-1/2 rounded-full bg-white/80 p-2 shadow-md transition hover:bg-white focus:outline-none md:-right-4'
            aria-label='Scroll right'
          >
            <FaChevronRight className='h-6 w-6 text-primary' />
          </button>
        </div>
        <Link href='/press' className='-mt-2 text-primary hover:underline'>
          {i18n.see_more}
        </Link>
      </FlexCol>
    </Section>
  )
}
